// extracted by mini-css-extract-plugin
export default {"right-container":"HeaderRight_right-container__jOn28","login":"HeaderRight_login__sWBxH","signup":"HeaderRight_signup__-ZdSf"};